import React from "react"
import styled from "styled-components"
import { ImageContainer } from "../elements"
import { breakpointLarge } from "../variables"
import PostTextSnippet from "./postTextSnippet"

const PostFeatured = ({ post }) => {
  const { featured_image } = post.data

  const url = featured_image && featured_image.localFile.childImageSharp.fluid
  const alt = featured_image && featured_image.alt

  return (
    <FeaturedPostContainer>
      <PostTextSnippet post={post} isFeatured={true} />
      {featured_image && (
        <ImageContainer fluid={url} alt={alt} margin="10px 0 0 0" />
      )}
    </FeaturedPostContainer>
  )
}

export default PostFeatured

const FeaturedPostContainer = styled.div`
  margin-bottom: 75px;
  ${ImageContainer} {
    height: 376px;
  }

  @media (min-width: ${breakpointLarge}) {
    ${ImageContainer} {
      height: 478px;
    }
  }
`
